import React from 'react';
import { Navigate } from 'react-router-dom';

function ProtectedRoute({ children }) {
    const token = localStorage.getItem('adminToken');

    if (!token) return <Navigate to="/admin-login" replace />;

    try {
        const { exp } = JSON.parse(atob(token.split('.')[1]));
        if (Date.now() >= exp * 1000) {
            localStorage.removeItem('adminToken');
            return <Navigate to="/admin-login" replace />;
        }
    } catch {
        localStorage.removeItem('adminToken');
        return <Navigate to="/admin-login" replace />;
    }

    return children;
}

export default ProtectedRoute;
